import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledInlineContact from './InlineContact.style.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';

/* eslint-disable react/no-array-index-key */

const InlineContact = ({
  headline,
  copy,
  label,
  mail
}) => {
  return /*#__PURE__*/React$1.createElement(StyledInlineContact, null, /*#__PURE__*/React$1.createElement(Link$1, {
    href: `mailto:${mail}`,
    component: "a",
    target: "_blank",
    label: label,
    noHover: true,
    className: "inlineContact__link"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "inlineContact__headline"
  }, /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h2",
    variant: "headline",
    text: headline
  })), /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "copyIntro"
  }, copy)));
};

InlineContact.propTypes = {
  headline: PropTypes$1.string.isRequired,
  copy: PropTypes$1.string,
  label: PropTypes$1.string,
  mail: PropTypes$1.string.isRequired
};
InlineContact.defaultProps = {
  copy: null,
  label: null
};

export default InlineContact;
